import { Outlet } from 'react-router-dom';
import ManagementAreaProvider from './ManagementAreaProvider';

const ManagementAreaPage = () => {
  return (
    <div className="flex items-start w-full">
      <ManagementAreaProvider>
        <Outlet />
      </ManagementAreaProvider>
    </div>
  );
};

export default ManagementAreaPage;
